/* eslint-disable eslint-comments/disable-enable-pair, react/jsx-max-depth, react/jsx-no-literals */
import React from 'react';
import PropTypes from 'prop-types';
import ArrowRight from '@mdi/svg/svg/arrow-right.svg';

import 'src/components/ToolsBox.scss';

const ToolsBox = ({ link, icon: Icon, title, subtitle, testName, onClick }) => (
  <div data-test={testName} styleName="tool-box">
    <a href={link} title={title} onClick={onClick} styleName="tool-box__link">
      <div styleName="tool-box__content">
        <div styleName="tool-box__icon-box">
          <Icon viewBox="0 0 24 24" />
        </div>
        <div styleName="tool-description">
          <h3 styleName="tool-description__title">{title}</h3>
          <p styleName="tool-description__subtitle">
            {subtitle}
            <ArrowRight viewBox="0 0 24 24" />
          </p>
        </div>
      </div>
    </a>
  </div>
);

ToolsBox.defaultProps = {
  onClick: () => {},
};

ToolsBox.propTypes = {
  icon: PropTypes.func.isRequired,
  link: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  testName: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

export default ToolsBox;
